import { render, staticRenderFns } from "./CriminalConvictions.vue?vue&type=template&id=5e150c00&"
import script from "./CriminalConvictions.vue?vue&type=script&lang=js&"
export * from "./CriminalConvictions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports